import NoCourseModal from './NoCourseModal';

export default NoCourseModal;
